export default __webpack_public_path__ + "static/media/icon-drawing.7b83271f.png";